import React from 'react'
import { NextSeo } from 'next-seo';
import LinkWrap from '../components/LinkWrap';
import Button from '../components/Button';
import HeroHeader from '../components/HeroHeader';
import logo from '../public/Pictures/MSR-logo-flat-black.png'
import handTime from '../public/Pictures/hand-gesture.png'
import review from '../public/Pictures/review.png'
import handSuccess from '../public/Pictures/successHand.png'
import team from '../public/Pictures/Corporate-team.png'
import PicCont from '../components/PicCont'
import PastEvents from '../components/PastEvents'
import ClientReviews from '../components/ClientReviews'
import { wrapper } from '../store/configStore';
import axios from 'axios'
import { SERVER_IP } from '../store/middleware/api';
import { compactPublicEvents } from '../utilities/eventPublicPayload';
export const getStaticProps = wrapper.getStaticProps(
  async ({ store, preview,params }) => {


     const corp = await axios.request(`${SERVER_IP}/user/static-landing`)
   
     let {  newsletterevents, total_events } = corp?.data
     return {
         props: {
              newsletterevents: compactPublicEvents(newsletterevents), total_events
         }
     }
  }
);

const AboutUs = ({   newsletterevents, total_events}) => {



  return <>  <NextSeo   title='About Us - Miami Sound Rental'
  description='Learn more about Miami Sound Rental, your Audio Visual & DJ Equipment Provider in Miami and South Florida' 
  canonical="https://miamisoundrental.com/about-us"
  twitter={{
    handle: '@miamisoundrent1',
    site: '@miamisoundrent1',
    cardType: 'summary_large_image',
  }}
  openGraph={{
    type: 'website',
    url: 'https://miamisoundrental.com/about-us',
    title: 'About Us - Miami Sound Rental',
    description: 'Learn more about Miami Sound Rental, your Audio Visual & DJ Equipment Provider in Miami and South Florida'  ,
    images: [
      {
        url: 'https://dnw-server.s3.us-east-2.amazonaws.com/msr_og.jpg',
        width: 800,
        height: 600,
        alt: 'Miami Sound Rental',
      },

    ],
    site_name: 'Miami Sound Rental',
  }}
  />
  <div className='about-us'>
    <header className='header'>
      <div className='bold weAre'>We Are</div>
      <PicCont src={logo} width={720} height={432} />
      <h1 className='thick'>#1 Rated Audio Visual Partner in South Florida</h1>
    </header>
    <div className='pictureBack'>
    <PicCont priority background src={team} />
    <div className='textParent'> 
    <div className='textBox'> 
      <strong className='titS'>We offer a wide range of audio and visual equipment for rental and provide services for all kinds of events in South Florida.</strong>

      <p>
      We specialize in providing <strong> audio-visual equipment solutions</strong> for events of various natures:<br/><br/>

      <strong>Corporate</strong>: Meetings, conferences, team-building activities, product launches, trade-shows, etc.<br/><br/>

      <strong>Private Events</strong>: Weddings, birthdays,home celebrations, etc.<br/><br/>

      <strong>Public Events</strong>: festivals, fairs; political functions, etc.<br/><br/>

We offer a <strong>comprehensive, start-to-finish service</strong> that flexibly adapts to each client's needs.<br/><br/>

Our aim is to elevate the standards of service in the industry by leveraging our proprietary technology.<br/><br/>

<strong>We service all types of events</strong>, from private to large corporate conferences.
        </p>
      </div>
      </div>
    <div className="back2">
      
      </div>
    <div className="back">
        <div className="backLeft"> </div>
        <div className="backRight"> </div>
        </div>
      </div>
    <section className="mission">
    <p className='ONLYPHONE'>
      We specialize in providing <strong> audio-visual equipment solutions</strong> for events of various natures:<br/><br/>

      <strong>Corporate</strong>: Meetings, conferences, team-building activities, product launches, trade-shows, etc.<br/><br/>

      <strong>Private Events</strong>: Weddings, birthdays,home celebrations, etc.<br/><br/>

      <strong>Public Events</strong>: festivals, fairs; political functions, etc.<br/><br/>

We offer a <strong>comprehensive, start-to-finish service</strong> that flexibly adapts to each client's needs.<br/><br/>

Our aim is to elevate the standards of service in the industry by leveraging our proprietary technology.<br/><br/>

<strong>We service all types of events</strong>, from private to large corporate conferences.
        </p>
      <div className="col">
        <h2 className='bold' >Our mission is to be your trustworthy AV partner.</h2>
        <p>That&apos;s why, by leveraging our technology, we&apos;ve developed a robust, yet agile, operations model that positions us as:</p>
      </div>
      <div className="row">
        <div className="colIcon">
          <PicCont height={512} width={512} src={handSuccess} />
          <div className='infoCol'>
          <strong>Extremely Convenient</strong>
          <p>We offer custom-made AV solutions for events of any type and size, and we do it in minutes thanks to our advanced technology.</p>
        </div>
        </div>
        <div className="colIcon">
          <PicCont height={512} width={512} src={handTime} />
          <div className='infoCol'>
          <strong>Quick & Transparent</strong>
          <p>Our system automatically generates transparent and accurate pricing tailored to the actual needs of EACH event.</p>
        </div>
        </div>
        <div className="colIcon">
          <PicCont height={512} width={512} src={review} />
          <div className='infoCol'>
          <strong>Reliable</strong>
          <p>Thanks to data-driven service planning and delivery, we ensure flawless execution and a significant reduction in human errors.</p>
        </div>
        </div>
      </div>
    </section>
    <section className='special'>
      <h3 className='bold'>We specialize in providing start-to-finish AV services for all types of events</h3>

      <div className='row'>
          <div className='gradCard'>
              <strong>Meetings & Conferences</strong>
              <p>Professional Audio Systems to ensure crystal-clear communication.<br/><br/>
Visual Solutions that enhance presentations.<br/><br/>
Lighting Design that sets the tone for meetings and presentations.<br/><br/>
Technical Support</p>
          </div>
          <div className='gradCard'>
              <strong>Conventions & Trade Shows</strong>
              <p>Comprehensive Audio-Visual Solutions for diverse booth and stage requirements.<br/><br/>
Exhibit Booth Setup.<br/><br/>
Lighting Design that maximizes attendees engagement.<br/><br/>
Technical Support and Coordination.</p>
          </div>
          <div className='gradCard'>
              <strong>Entertainment & Live Events</strong>
              <p>Professional Audio Systems for impeccable sound quality.<br/><br/>
                 Visual Solutions for live feeds and background visuals.<br/><br/>
Lighting Design to complement the mood of the event.<br/><br/>
DJ & Live Music Coordination</p>
          </div>
          <div className='gradCard'>
              <strong>Weddings & Celebrations</strong>
              <p>Profesional audio that ensures excellent attendee experience.<br/><br/>
Visual Solutions that enhance the celebration experience. <br/><br/>
Lighting Design setting the tone for celebration. <br/><br/>
Technical Support and Coordination</p>
          </div>
        </div>
      </section>
      <ClientReviews ui='v2' />
      <PastEvents ui='v2' newsletterevents={newsletterevents} total_events={total_events} />
 

   
    


  </div>

  </>
}

export default AboutUs
